export function isLoginApp() {
    return new Promise(resolve => {
      WBAPP.action.isLogin(state => resolve(parseInt(state)))
    })
  }
  
export function getUidFromApp() {
    return new Promise(resolve => {
      WBAPP.action.getUserInfo('uid', uid => resolve(uid))
    })
  }
  const specialPackageConfig = {
    "huawei":{
      channelid:"1169",
      intermanufacturer:"huawei",
      version:"8.2.0"
    },
    "xiaomi":{
      channelid:"1015",
      intermanufacturer:"xiaomi",
      version:"8.2.0"
    },
    "oppo":{
      channelid:"1070",
      intermanufacturer:"oppo",
      version:"8.2.0"
    },
    "vivo":{
      channelid:"1071",
      intermanufacturer:"vivo",
      version:"8.2.0"
    },
  }
  export function isSpecialPackage() {
    return new Promise(resolve => {
    try {
      WBAPP.action.getUserInfo('', resp => {
        const { version,channelid,intermanufacturer} = JSON.parse(resp);
        for(let i in specialPackageConfig){
          if(version==specialPackageConfig[i].version&&channelid==specialPackageConfig[i].channelid&&intermanufacturer==specialPackageConfig[i].intermanufacturer){
            resolve(i);
            break;
          }
        }
        resolve(false);
    })
    } catch (error) {
      resolve(false);
    }
  })
}
 
  export function getPositionFromApp() {
    return new Promise(resolve => {
      WBAPP.action.getUserInfo('', resp => {
        const { lat: latitude, lon: longitude } = JSON.parse(resp);
        resolve({ latitude, longitude })
      })
    })
  }
  
  
  export function loadNativeDetail({ listName, infoId, localName, fullPath, tjfrom }) {
    WBAPP.extend.pagetrans.loadNativeDetail('job', listName, infoId, localName, fullPath, { common_params:{ slot: tjfrom + '__' + SYSTEM } })
  }
  
  export function setWeblog(logTag) {
    WBAPP.action.setWeblog(logTag, 'click', { cate: '', params:[] })
  }
  
  export function goZpIndexNativePage(){
    WBAPP.invoke('pagetrans',{
        tradeline:'job',
        action:'pagetrans',
        content:{
            pagetype:"fullTimeCate",
            autojump: "false",
            list_name: "job",
            maintype: "cMainPage",
            pageIndex: 0,
            showsift: 1,
            url: "https://zprecommend.58.com/api/jobindex"
            // params:{
            //     "title": "全职招聘",
            //     "showsift": "true",
            //     "list_name": "job",
            //     "autojump": "false",
            //     "maintype": "cMainPage",
            //     "pageIndex": 0,
            //     //"url": "https://zprecommend.58.com/api/jobindex"
            // }
        }
    });
  }
  export function goCommonPage(url,title="",pageCarrier="common"){
    WBAPP.action.pagetrans('core',{
        pagetype:pageCarrier,
        title,
        url,
    });
  }

 export function setlog(actionType,opts={},pageType="chatbot"){
   console.log('埋点',actionType)
  //opts 为Object对象数据，对象中可包含的字段为 params(参数) 及 cate
  WBAPP.action.setWeblog(pageType,actionType,opts);
 }

//   export function addShareBtn() {
//     WBAPP.action.extendBtn([{
//       key: 'share',
//       txt: '分享',
//       icon: 'share'
//     }], (key, index) => {
//       if(key == 'share') {
//         const shareOpt = {
//           url: window.location.href,
//           title: '58招聘助手',
//           content: '一个可以帮您找工作的AI',
//           imgUrl: 'http://hrgbot.58.com/static/img/bot.7d3f0d8.png'
//         }
//         WBAPP.action.share([{
//           shareto: 'WEIXIN',
//           url: shareOpt.url,
//           title: shareOpt.title,
//           content: shareOpt.content,
//           img_url: shareOpt.imgUrl,
//       },{
//           shareto:'FRIENDS' ,
//           url: shareOpt.url,
//           title: shareOpt.title,
//           img_url: shareOpt.imgUrl,
//       }],(state,source) => {
//         setlog('shareToWX')
//       })
//       }
//     })
//   }